(function () {
    'use strict';

    angular
        .module('backApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('process', {
                parent: 'entity',
                url: '/process?page&sort&search',
                data: {
                    authorities: ['ROLE_PROCESS_OPERATION'],
                    pageTitle: 'backApp.process.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/process/processes.html',
                        controller: 'ProcessController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('process');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('process.edit', {
                parent: 'process',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_PROCESS_OPERATION']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/process/process-dialog.html',
                        controller: 'ProcessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('process');
                                return $translate.refresh();
                            }],
                            entity: ['Process', function (Process) {
                                return Process.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('process', null, {reload: 'process'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
